module.exports = __webpack_public_path__ + "media/images/icons/customer-35df87958af5d1b383c67d20c7de51fa.svg";